import accessories_1 from "./accessories-1"
import accessories_6 from "./accessories-6"
import accessories_3 from "./accessories-3"
import accessories_8 from "./accessories-8"
import accessories_5 from "./accessories-5"
import accessories_10 from "./accessories-10"
import accessories_11 from './accessories-11'
import accessories_12 from './accessories-12'
import accessories_13 from './accessories-13'
import accessories_14 from './accessories-14'
import all from './all'

const list = [
  accessories_1,
  accessories_6,
  accessories_3,
  accessories_8,
  accessories_5,
  accessories_10,
  accessories_11,
  accessories_12,
  accessories_13,
  accessories_14,
  all,
]
export default list